import Compare from './components/Compare'
import CompareSave from './components/CompareSave'
import Main from './components/Main'
import Save from './components/Save'

const Buttons = {
  CompareSave,
  Main,
  Save,
  Compare,
}

export default Buttons
